import { useEffect, useRef } from 'react'

import { MainInventoryMapper, useInventoryStoreBase, useUser } from '@store'

export const useFetchRechargedReward = (enabled: boolean) => {
  const alreadyFetched = useRef(false)
  const { claimRechargeDrop } = useUser().actions
  const { addCard } = useInventoryStoreBase.getState().actions

  useEffect(() => {
    if (alreadyFetched.current) {
      return
    }

    if (!enabled) {
      return
    }

    alreadyFetched.current = true
    claimRechargeDrop().then((reward) => {
      if (reward) {
        addCard(MainInventoryMapper.mapFromBackend(reward))
      }
    })
  }, [enabled])
}
